import { useState, useEffect } from 'react';
import { RoleTag } from 'lib/types';
import { Autocomplete, TextField } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { useApi } from 'lib/contexts/ApplicationState';

type RoleTagSelectValue = (string | RoleTag)[];

export interface Props {
  label: string;
  onChange: (value: RoleTagSelectValue) => void;
  value: RoleTagSelectValue;
  size?: 'small' | 'medium';
  getSuggestions?: (arg: RoleTagSelectValue) => void;
  addNew?: boolean;
}

const filterOptions = createFilterOptions({
  stringify: (option: RoleTag) => option.name,
});

export const RoleTagSelect = ({
  label, onChange, value, size, getSuggestions, addNew = false,
}: Props) => {
  const [roleTags, setRoleTags] = useState<RoleTag[]>();
  const API = useApi();

  useEffect(() => {
    const getRoleTags = async () => {
      const allRoleTags = await API.listAllRoleTags();
      setRoleTags(allRoleTags);
    };
    getRoleTags();
  }, [API]);

  const renderSelectedLabel = (option: RoleTag) => {
    if (!option.id) {
      return `add new category: ${option.name}`;
    }
    return option.name;
  };

  return (
    <Autocomplete
      freeSolo={addNew}
      multiple
      options={roleTags || []}
      getOptionLabel={(option) => renderSelectedLabel(option)}
      onChange={(_, v) => {
        onChange(v);
        getSuggestions?.(v);
      }}
      value={value}
      filterOptions={filterOptions}
      isOptionEqualToValue={(option, v) => option?.id === v?.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label || 'Categories'}
          variant="outlined"
          value={value}
          {...(size && { size })}
        />
      )}
    />
  );
};
